// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-container {
  display: flex;
  flex-direction: row;
  width: 49px;
}
.notification-container .notification-inner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 20px;
}
.notification-container .notification-inner-container:hover {
  background-color: #f08613;
  cursor: pointer;
}
.notification-container .notification-popup {
  margin-top: 7px;
  margin-left: 900px;
}
.notification-container .notification-popup .css-3bmhjh-MuiPaper-root-MuiPopover-paper {
  border: 2px solid #f08613;
  min-width: 339px;
  min-height: 300px;
}
.notification-container .notification-popup .css-1dmzujt {
  border: 2px solid #f08613;
  min-width: 339px;
  min-height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/Layout/Header/Notification/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AACJ;AAAI;EACE,yBAAA;EACA,eAAA;AAEN;AAKE;EACE,eAAA;EACA,kBAAA;AAHJ;AAKI;EACE,yBAAA;EACA,gBAAA;EACA,iBAAA;AAHN;AAMI;EACE,yBAAA;EACA,gBAAA;EACA,iBAAA;AAJN","sourcesContent":[".notification-container {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 49px;\r\n\r\n  .notification-inner-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 40px;\r\n    height: 40px;\r\n    border-radius: 20px;\r\n    &:hover {\r\n      background-color: #f08613;\r\n      cursor: pointer;\r\n    }\r\n    // @media (max-width: 1138px) {\r\n    //   height: 3vh;\r\n    // }\r\n  }\r\n\r\n  .notification-popup {\r\n    margin-top: 7px;\r\n    margin-left: 900px;\r\n\r\n    .css-3bmhjh-MuiPaper-root-MuiPopover-paper {\r\n      border: 2px solid #f08613;\r\n      min-width: 339px;\r\n      min-height: 300px;\r\n    }\r\n\r\n    .css-1dmzujt {\r\n      border: 2px solid #f08613;\r\n      min-width: 339px;\r\n      min-height: 300px;\r\n    }\r\n\r\n    // .menu-item{\r\n    //     margin: 4px;\r\n    //     border: 2px solid #EDEDED;\r\n    // }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
